<script setup lang="ts">
import { screenReaderMessageContainerId } from "@/constants/screenReader.ts";
</script>

<template>
  <div :id="screenReaderMessageContainerId" aria-live="assertive" class="screenreader-only" />
</template>
